import AddGoals from './component'
export default AddGoals
